import { fork } from "redux-saga/effects";
import {
  handleAddInAppNotificationMessage,
  handleHiddenInAppNotificationMessage,
} from "./app_notification_message_handler";
import {
  handleApplyClientInAuth,
  handleCreateInAuth,
  handleGetMeInLayout,
  handleLoginInAuth,
  handleLogoutInAuth,
  handlePasswordResetInAuth,
  handleRequestOffAuthListenerInAuth,
  handleRequestOnAuthListenerInAuth,
} from "./auth_handler";
import {
  handleCreatePaymentInfoInClientClientBilling,
  handleGetCompanyInClientClientBilling,
} from "./client_billing_handler";
import { handleGetAllClientBookmarksInClientClientBookmarks } from "./client_client_bookmarks_handler";
import { handleGetAllClientBrowsingHistoriesInClientClientBrowsingHistories } from "./client_client_browsing_histories_handler";
import {
  handleCreateClientInClientClients,
  handleDeleteClientInClientClients,
  handleGetAllClientsInClientClients,
  handleUpdateRoleClientInClientClients,
} from "./client_clients_handler";
import {
  handleApproveContractInClientContract,
  handleOpenCreateFormContractInClientContract,
  handleUpdateContractInClientContract,
} from "./client_contract_handler";
import { handleGetAllByClientInClientContractList } from "./client_contracts_handler";
import { handleGetCustomerInClientCustomer } from "./client_customer_handler";
import { handleGetAllEntriesInClientEntries } from "./client_entries_handler";
import {
  handleCreateMessageRoomInClientMessageRoom,
  handleDestroyMessageRoomInClientMessageRoom,
  handleSendMessageRoomInClientMessageRoom,
} from "./client_message_room_handler";
import { handlePollTaskWatcherInClientMessageRooms } from "./client_message_rooms_handler";
import {
  handleGetMeClientInClientMypage,
  handleUpdateClientInClientMypage,
  handleUpdateCompanyInClientMypage,
  handleUpdateEmailInClientMypage,
  handleUpdatePasswordInClientMypage,
} from "./client_mypage_handler";
import { handleGetCustomersInPmCampaignPage } from "./client_pm_campaign_handler";
import { handleGetCustomersInSalesCampaignPage } from "./client_sales_campaign_handler";
import { handleGetCustomersInIpoCampaignPage } from "./client_ipo_campaign_handler";
import {
  handleCloseProjectDetailInClientProjectDetail,
  handleCreateProjectDetailInClientProjectDetail,
  handleDraftProjectDetailInClientProjectDetail,
  handleGetProjectDetailInClientProjectDetail,
  handleOpenProjectDetailInClientProjectDetail,
  handleUpdateProjectDetailInClientProjectDetail,
} from "./client_project_handler";
import {
  handleCopyProject,
  handleGetAllByClientProjectListInClientProjectList,
} from "./client_projects_handler";
import {
  handleCopyHighlightsInClientScoutCustomer,
  handleCreateClientBookmarkInClientScoutCustomer,
  handleCreateScoutInClientScoutCustomer,
  handleDeleteClientBookmarkInClientScoutCustomer,
  handleDeleteHighlightsInClientScoutCustomer,
  handleGetCustomerInClientScoutCustomer,
} from "./client_scout_customer_handler";
import { handleSearchCustomerListInClientScoutCustomerList } from "./client_scout_customers_handler";
import { handleGetCustomersInClientTopPage } from "./client_top_page_handler";
import {
  handleAddCustomerBlackListInCustomerBlackList,
  handleDeleteCustomerBlackListInCustomerBlackList,
  handleGetCustomerBlackListInCustomerBlackList,
} from "./customer_black_list_handler";
import { handleGetEntryProjectsInCustomerEntries } from "./customer_entries_handler";
import {
  handleCreateMessageRoomInCustomerMessageRoom,
  handleDestroyMessageRoomInCustomerMessageRoom,
  handleSendMessageRoomInCustomerMessageRoom,
} from "./customer_message_room_handler";
import { handlePollTaskWatcherInCustomerMessageRooms } from "./customer_message_rooms_handler";
import {
  handleDestroyCustomerPDFInCustomerMypage,
  handleGenerateCustomerPDFInCustomerMypage,
  handleGetMeCustomerInCustomerMypage,
  handleUpdateCustomerInCustomerMypage,
  handleUpdateEmailInCustomerMypage,
  handleUpdatePasswordInCustomerMypage,
} from "./customer_mypage_handler";
import {
  handleCreateEntryInCustomerProject,
  handleDeleteEntryInCustomerProject,
  handleGetEntryProjectsInCustomerProject,
  handleGetProjectInCustomerProject,
} from "./customer_project_handler";
import {
  handleGetEntryNumOrderProjectListInCustomerProjectList,
  handleGetProjectCountInCustomerProjectList,
  handleGetProjectListInCustomerProjectList,
  handleSearchProjectListInCustomerProjectList,
} from "./customer_projects_handler";
import { handleGetMeCustomerInCustomerTopPage } from "./customer_top_page_handler";
import { handleGetAllByRecommendProjectListInCustomerTutorial } from "./customer_tutorial_handler";
import {
  handleGetMultiSkillTagList,
  handleGetSingleSkillTagList,
} from "./skill_tag_handler";

function* rootHandler() {
  yield fork(handleAddInAppNotificationMessage);
  yield fork(handleHiddenInAppNotificationMessage);

  yield fork(handleRequestOnAuthListenerInAuth);
  yield fork(handleRequestOffAuthListenerInAuth);
  yield fork(handleLoginInAuth);
  yield fork(handleLogoutInAuth);
  yield fork(handlePasswordResetInAuth);
  yield fork(handleCreateInAuth);
  yield fork(handleApplyClientInAuth);
  yield fork(handleGetMeInLayout);

  yield fork(handleGetAllByRecommendProjectListInCustomerTutorial);

  yield fork(handleGetMeCustomerInCustomerTopPage);

  yield fork(handleGetEntryProjectsInCustomerEntries);

  yield fork(handleGetMeCustomerInCustomerMypage);
  yield fork(handleUpdateCustomerInCustomerMypage);
  yield fork(handleUpdatePasswordInCustomerMypage);
  yield fork(handleUpdateEmailInCustomerMypage);
  yield fork(handleDestroyCustomerPDFInCustomerMypage);
  yield fork(handleGenerateCustomerPDFInCustomerMypage);

  yield fork(handleGetCustomerBlackListInCustomerBlackList);
  yield fork(handleAddCustomerBlackListInCustomerBlackList);
  yield fork(handleDeleteCustomerBlackListInCustomerBlackList);

  yield fork(handleGetEntryNumOrderProjectListInCustomerProjectList);
  yield fork(handleGetProjectListInCustomerProjectList);
  yield fork(handleSearchProjectListInCustomerProjectList);
  yield fork(handleGetProjectCountInCustomerProjectList);

  yield fork(handleGetProjectInCustomerProject);
  yield fork(handleCreateEntryInCustomerProject);
  yield fork(handleDeleteEntryInCustomerProject);
  yield fork(handleGetEntryProjectsInCustomerProject);

  yield fork(handleCreateProjectDetailInClientProjectDetail);

  yield fork(handlePollTaskWatcherInCustomerMessageRooms);

  yield fork(handleCreateMessageRoomInCustomerMessageRoom);
  yield fork(handleSendMessageRoomInCustomerMessageRoom);
  yield fork(handleDestroyMessageRoomInCustomerMessageRoom);

  yield fork(handleUpdateContractInClientContract);
  yield fork(handleOpenCreateFormContractInClientContract);
  yield fork(handleApproveContractInClientContract);

  yield fork(handleGetAllByClientInClientContractList);

  yield fork(handleGetMeClientInClientMypage);
  yield fork(handleUpdateCompanyInClientMypage);
  yield fork(handleUpdateClientInClientMypage);
  yield fork(handleUpdatePasswordInClientMypage);
  yield fork(handleUpdateEmailInClientMypage);

  yield fork(handleCreateMessageRoomInClientMessageRoom);
  yield fork(handleSendMessageRoomInClientMessageRoom);
  yield fork(handleDestroyMessageRoomInClientMessageRoom);

  yield fork(handlePollTaskWatcherInClientMessageRooms);

  yield fork(handleGetProjectDetailInClientProjectDetail);
  yield fork(handleUpdateProjectDetailInClientProjectDetail);
  yield fork(handleDraftProjectDetailInClientProjectDetail);
  yield fork(handleOpenProjectDetailInClientProjectDetail);
  yield fork(handleCloseProjectDetailInClientProjectDetail);

  yield fork(handleGetAllByClientProjectListInClientProjectList);

  yield fork(handleGetAllEntriesInClientEntries);

  yield fork(handleGetCustomerInClientCustomer);

  yield fork(handleSearchCustomerListInClientScoutCustomerList);

  yield fork(handleGetCustomerInClientScoutCustomer);
  yield fork(handleCreateScoutInClientScoutCustomer);
  yield fork(handleCreateClientBookmarkInClientScoutCustomer);
  yield fork(handleDeleteClientBookmarkInClientScoutCustomer);
  yield fork(handleCopyHighlightsInClientScoutCustomer);
  yield fork(handleDeleteHighlightsInClientScoutCustomer);

  yield fork(handleGetAllClientsInClientClients);
  yield fork(handleCreateClientInClientClients);
  yield fork(handleUpdateRoleClientInClientClients);
  yield fork(handleDeleteClientInClientClients);

  yield fork(
    handleGetAllClientBrowsingHistoriesInClientClientBrowsingHistories
  );
  yield fork(handleGetAllClientBookmarksInClientClientBookmarks);

  yield fork(handleGetCustomersInClientTopPage);

  yield fork(handleGetCompanyInClientClientBilling);
  yield fork(handleCreatePaymentInfoInClientClientBilling);

  yield fork(handleGetCustomersInPmCampaignPage);
  yield fork(handleGetCustomersInSalesCampaignPage);
  yield fork(handleGetCustomersInIpoCampaignPage);

  yield fork(handleGetSingleSkillTagList);
  yield fork(handleGetMultiSkillTagList);

  yield fork(handleCopyProject);
}

export default rootHandler;



// WEBPACK FOOTER //
// ./src/presentation/handler/app_handler.ts